import React from 'react';
import { DynamicContainer, Form, FormSection } from '@hai/ui-react';
import { FormikProps } from 'formik';
import { useTranslation } from 'react-i18next';
import { FormValue } from 'src/js/component/base/form/form-value';

import { DateAndTimeFormValues } from './date-and-time-form';
import { FormikTextfield } from 'src/js/component/base/form/formik-textfield';
import { FormikSelect } from 'src/js/component/base/form/formik-select';
import { PTP_ANNOUNCEMENT_INTERVAL, PTP_DELAY_MECHANISM, PTP_SYNC_INTERVAL } from './date-and-time-view-model';
import { enumValues } from 'src/js/helper/enum-helper';

interface Props {
  formikProps?: FormikProps<DateAndTimeFormValues>;
  initials?: DateAndTimeFormValues;
  stats: DateAndTimeFormValues;
}

export const PTP = (props: Props) => {
  const { t } = useTranslation();

  const { initials, stats } = props;

  const announcementIntervalHint =
    initials.domainNumber !== stats.domainNumberNmos && `${t('general.actual')} ${stats.domainNumberNmos}`;

  const announcementTimeoutHint =
    initials.announcementTimeout !== stats.announcementTimeoutNmos &&
    `${t('general.actual')} ${stats.announcementTimeoutNmos}`;

  return (
    <Form className="hai-mt-6 hai-mb-6">
      <FormSection title={t('settings.dateTime.section.ptp.title')}>
        <DynamicContainer minColumns={3} className="mk-dynamic-form">
          <FormValue
            label={t('settings.dateTime.section.ptp.clockState')}
            icon={stats.clockLedIcon}
            value={stats.clockLockState}
          />
          <FormValue label={t('settings.dateTime.section.ptp.clockId')} value={stats.clockId} />
        </DynamicContainer>

        <DynamicContainer minColumns={3} className="mk-dynamic-form">
          <FormikTextfield
            name="domainNumber"
            title={t('settings.dateTime.section.ptp.domainNumber')}
            hint={announcementIntervalHint}
            alwaysShowHint
          />

          <FormikSelect
            name="announcementInterval"
            title={t('settings.dateTime.section.ptp.announcementInterval')}
            selectValues={enumValues(PTP_ANNOUNCEMENT_INTERVAL)}
            selectLabels={enumValues(PTP_ANNOUNCEMENT_INTERVAL).map((value) =>
              t(`settings.dateTime.section.ptp.enums.announcementInterval.${value}`),
            )}
          />

          <FormikTextfield
            name="announcementTimeout"
            title={t('settings.dateTime.section.ptp.announcementTimeout')}
            hint={announcementTimeoutHint}
            alwaysShowHint
          />

          <FormikSelect
            name="syncInterval"
            title={t('settings.dateTime.section.ptp.syncInterval')}
            selectValues={enumValues(PTP_SYNC_INTERVAL)}
            selectLabels={enumValues(PTP_SYNC_INTERVAL).map((value) =>
              t(`settings.dateTime.section.ptp.enums.syncInterval.${value}`),
            )}
          />

          <FormikSelect
            name="delayMechanism"
            title={t('settings.dateTime.section.ptp.delayMechanism')}
            selectValues={enumValues(PTP_DELAY_MECHANISM)}
            selectLabels={enumValues(PTP_DELAY_MECHANISM).map((value) =>
              t(`settings.dateTime.section.ptp.enums.delayMechanism.${value}`),
            )}
          />
        </DynamicContainer>
      </FormSection>
    </Form>
  );
};
